"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionHeadingComponent = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

function SectionHeadingComponent(_ref) {
  var centered = _ref.centered,
      half = _ref.half,
      inverted = _ref.inverted,
      heading = _ref.heading,
      text = _ref.text,
      sloganText = _ref.sloganText,
      slogan = _ref.slogan,
      isDarkMode = _ref.isDarkMode;
  return react_1.default.createElement("div", {
    className: " py-8 flex  flex-wrap ".concat(centered ? 'flex-col justify-center items-center' : '', " ").concat(inverted ? 'text-white bg-black p-4' : '', " ").concat(half ? 'flex-col justify-center items-center md:items-start' : 'items-center', " ").concat(isDarkMode ? 'text-white' : '')
  }, react_1.default.createElement("div", {
    className: "  ".concat(centered ? 'flex flex-col items-center' : half ? 'w-full flex items-center flex-col md:block' : 'flex items-center flex-col md:block md:pr-48 w-full md:w-1/2', " \n              \n              ")
  }, react_1.default.createElement("h2", {
    className: "mt-4 text-4xl text-center md:text-left"
  }, heading !== null && heading !== void 0 ? heading : 'Section Heading')), text && react_1.default.createElement("div", {
    className: " max-w-lg py-4 ".concat(half ? 'w-full' : 'w-full md:w-1/2')
  }, react_1.default.createElement("p", {
    className: " ".concat(centered ? 'text-center  md:px-12' : 'text-center md:text-left md:pr-24')
  }, text !== null && text !== void 0 ? text : 'Lorem ipsum text')));
}

exports.SectionHeadingComponent = SectionHeadingComponent;
SectionHeadingComponent.propTypes = {
  centered: prop_types_1.default.bool,
  half: prop_types_1.default.bool,
  inverted: prop_types_1.default.bool,
  slogan: prop_types_1.default.string,
  sloganText: prop_types_1.default.string,
  text: prop_types_1.default.string,
  heading: prop_types_1.default.string,
  isDarkMode: prop_types_1.default.bool
};
SectionHeadingComponent.defaultProps = {
  centered: false,
  half: false,
  inverted: false,
  slogan: 'outlined',
  isDarkMode: false
};